import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui remet le scroll en haut de la page à chaque changement de route
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll instantané vers le haut de la page
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
